import { DateTime } from "luxon";
import { z } from "zod";
import { zKlus } from "@personeel/gen/hey-api/zod.gen";

// 1) DTO-schema direct uit OpenAPI (geen app-transforms)
const KlusApiSchema = zKlus.strip();

// 2) Alleen velden met speciale transformatie/afwijkend type
const klusModelOverrides = {
  // In de API mag id nullable zijn, in de UI gebruiken we een verplicht nummer
  id: z.number(),
  beginDatumtijd: z.iso.datetime({ offset: true }).transform((val) => DateTime.fromISO(val)),
  eindDatumtijd: z.iso.datetime({ offset: true }).transform((val) => DateTime.fromISO(val)),
  lastModified: z.iso.datetime({ offset: true }).nullish(),
} satisfies z.ZodRawShape;

export const KlusModelSchema = KlusApiSchema.extend(klusModelOverrides);

export const KlusModelArraySchema = z.array(KlusModelSchema);

export type KlusModel = z.infer<typeof KlusModelSchema>;
